import React, { FunctionComponent } from "react";
import Grid from "@material-ui/core/Grid";
import CardSolution from "shared/components/CardSolution/CardSolution";
import CardSolutionSkeleton from "shared/components/CardSolution/CardSolutionSkeleton/CardSolutionSkeleton";
import orderBy from "lodash/orderBy";

const ProfileSolutions: FunctionComponent<{ solutions: any }> = ({
  solutions,
}) => {
  return (
    <div>
      {solutions ? (
        solutions.length === 0 ? (
          <h4 style={{ color: "var(--grey-4)" }}>No projects found</h4>
        ) : (
          <Grid container direction="row" spacing={3}>
            {orderBy(solutions, "createdAt", "desc").map((solution: any) => (
              <Grid item xs={12} md={6} key={solution.id}>
                <CardSolution solution={solution} showFeedBackButton={false} />
              </Grid>
            ))}
          </Grid>
        )
      ) : (
        <Grid container direction="row" spacing={3}>
          {[0, 1, 2, 3, 4, 5].map((number) => (
            <Grid item xs={12} md={6} key={number}>
              <CardSolutionSkeleton key={number} />
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default ProfileSolutions;
